import { Controller } from '@hotwired/stimulus'

/**
 * @description Stimulus controller to live update an image with an uploaded file
 */
export default class ImagePreviewController extends Controller {
  static targets = ['imageUpload', 'imageDestination']
  static values = { defaultPreview: String }

  connect() {
    if (this.hasDefaultPreviewValue) {
      this.imageDestinationTarget.onerror = () => {
        this.imageDestinationTarget.src = this.defaultPreviewValue
      }
    }
  }

  show() {
    const uploadedFile = this.imageUploadTarget.files[0]
    if (uploadedFile.type.startsWith('image/')) {
      const imageSrc = URL.createObjectURL(uploadedFile)
      if (imageSrc) {
        this.imageDestinationTarget.src = imageSrc
      }
    }
  }
}
